@file:OptIn(InternalResourceApi::class)

package com.hyperether.goodjob.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.hyperether.goodjob.resources/"

public val Res.string.contact_person: StringResource by lazy {
      StringResource("string:contact_person", "contact_person", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6318, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5418, 42),
      ))
    }

public val Res.string.contact_site: StringResource by lazy {
      StringResource("string:contact_site", "contact_site", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6361, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5461, 36),
      ))
    }

public val Res.string.contact_type: StringResource by lazy {
      StringResource("string:contact_type", "contact_type", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6534, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5630, 36),
      ))
    }

public val Res.string.contact_type_contractor: StringResource by lazy {
      StringResource("string:contact_type_contractor", "contact_type_contractor", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6406, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5498, 47),
      ))
    }

public val Res.string.contact_type_customer: StringResource by lazy {
      StringResource("string:contact_type_customer", "contact_type_customer", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6454, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5546, 41),
      ))
    }

public val Res.string.contact_type_supplier: StringResource by lazy {
      StringResource("string:contact_type_supplier", "contact_type_supplier", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6492, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5588, 41),
      ))
    }

public val Res.string.contact_updated_successfully: StringResource by lazy {
      StringResource("string:contact_updated_successfully", "contact_updated_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6571, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5667, 76),
      ))
    }

public val Res.string.contact_us: StringResource by lazy {
      StringResource("string:contact_us", "contact_us", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6652, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5744, 34),
      ))
    }

public val Res.string.contacting_support_for_assistance: StringResource by lazy {
      StringResource("string:contacting_support_for_assistance", "contacting_support_for_assistance", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6699, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5779, 133),
      ))
    }

public val Res.string.contacts: StringResource by lazy {
      StringResource("string:contacts", "contacts", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6833, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5913, 28),
      ))
    }

public val Res.string.continue_cancellation: StringResource by lazy {
      StringResource("string:continue_cancellation", "continue_cancellation", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6890, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5970, 57),
      ))
    }

public val Res.string.continue_with_apple: StringResource by lazy {
      StringResource("string:continue_with_apple", "continue_with_apple", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6960, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6028, 55),
      ))
    }

public val Res.string.continue_with_fb: StringResource by lazy {
      StringResource("string:continue_with_fb", "continue_with_fb", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7012, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6084, 56),
      ))
    }

public val Res.string.continue_with_google: StringResource by lazy {
      StringResource("string:continue_with_google", "continue_with_google", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7065, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6141, 56),
      ))
    }

public val Res.string.continue_with_microsoft: StringResource by lazy {
      StringResource("string:continue_with_microsoft", "continue_with_microsoft", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7118, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6198, 63),
      ))
    }

public val Res.string.continue_with_next_step: StringResource by lazy {
      StringResource("string:continue_with_next_step", "continue_with_next_step", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7178, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6262, 63),
      ))
    }

public val Res.string.country: StringResource by lazy {
      StringResource("string:country", "country", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7311, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6379, 27),
      ))
    }

public val Res.string.country_required: StringResource by lazy {
      StringResource("string:country_required", "country_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7254, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6326, 52),
      ))
    }

public val Res.string.create: StringResource by lazy {
      StringResource("string:create", "create", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7865, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6905, 22),
      ))
    }

public val Res.string.create_new_employee: StringResource by lazy {
      StringResource("string:create_new_employee", "create_new_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7335, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6407, 119),
      ))
    }

public val Res.string.create_new_task: StringResource by lazy {
      StringResource("string:create_new_task", "create_new_task", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7467, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6527, 127),
      ))
    }

public val Res.string.create_one: StringResource by lazy {
      StringResource("string:create_one", "create_one", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7595, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6655, 34),
      ))
    }

public val Res.string.create_strong_password: StringResource by lazy {
      StringResource("string:create_strong_password", "create_strong_password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7626, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6690, 94),
      ))
    }

public val Res.string.create_workspace: StringResource by lazy {
      StringResource("string:create_workspace", "create_workspace", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7733, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6785, 56),
      ))
    }

public val Res.string.create_your_first_team: StringResource by lazy {
      StringResource("string:create_your_first_team", "create_your_first_team", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7798, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6842, 62),
      ))
    }

public val Res.string.current_plan: StringResource by lazy {
      StringResource("string:current_plan", "current_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7892, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6928, 36),
      ))
    }

public val Res.string.custom: StringResource by lazy {
      StringResource("string:custom", "custom", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7933, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6965, 22),
      ))
    }

public val Res.string.daily_activities: StringResource by lazy {
      StringResource("string:daily_activities", "daily_activities", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7964, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6988, 48),
      ))
    }

public val Res.string.damage_desc: StringResource by lazy {
      StringResource("string:damage_desc", "damage_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8021, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7037, 39),
      ))
    }

public val Res.string.damage_title: StringResource by lazy {
      StringResource("string:damage_title", "damage_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8069, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7077, 48),
      ))
    }

public val Res.string.dashboard: StringResource by lazy {
      StringResource("string:dashboard", "dashboard", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8134, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7126, 29),
      ))
    }

public val Res.string.date: StringResource by lazy {
      StringResource("string:date", "date", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8247, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7215, 20),
      ))
    }

public val Res.string.date_error: StringResource by lazy {
      StringResource("string:date_error", "date_error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8164, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7156, 58),
      ))
    }

public val Res.string.day: StringResource by lazy {
      StringResource("string:day", "day", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8359, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7303, 15),
      ))
    }

public val Res.string.day_free_trial: StringResource by lazy {
      StringResource("string:day_free_trial", "day_free_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8268, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7236, 66),
      ))
    }

public val Res.string.deadline_and_duration: StringResource by lazy {
      StringResource("string:deadline_and_duration", "deadline_and_duration", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8375, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7319, 57),
      ))
    }

public val Res.string.december: StringResource by lazy {
      StringResource("string:december", "december", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8425, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7377, 28),
      ))
    }

public val Res.string.dedicated_support: StringResource by lazy {
      StringResource("string:dedicated_support", "dedicated_support", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8454, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7406, 69),
      ))
    }

public val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8670, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7590, 22),
      ))
    }

public val Res.string.delete_contact: StringResource by lazy {
      StringResource("string:delete_contact", "delete_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8540, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7476, 42),
      ))
    }

public val Res.string.delete_job: StringResource by lazy {
      StringResource("string:delete_job", "delete_job", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8587, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7519, 34),
      ))
    }

public val Res.string.delete_site: StringResource by lazy {
      StringResource("string:delete_site", "delete_site", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8626, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7554, 35),
      ))
    }

public val Res.string.describe_the_process: StringResource by lazy {
      StringResource("string:describe_the_process", "describe_the_process", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8697, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7613, 56),
      ))
    }

public val Res.string.details: StringResource by lazy {
      StringResource("string:details", "details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8758, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7670, 27),
      ))
    }

public val Res.string.document: StringResource by lazy {
      StringResource("string:document", "document", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8816, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7728, 28),
      ))
    }

public val Res.string.documents: StringResource by lazy {
      StringResource("string:documents", "documents", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8786, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7698, 29),
      ))
    }

public val Res.string.done_selecting_dates: StringResource by lazy {
      StringResource("string:done_selecting_dates", "done_selecting_dates", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8845, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7757, 36),
      ))
    }

public val Res.string.downgrading_to_lower: StringResource by lazy {
      StringResource("string:downgrading_to_lower", "downgrading_to_lower", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 8882, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7794, 124),
      ))
    }

public val Res.string.due_date: StringResource by lazy {
      StringResource("string:due_date", "due_date", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9035, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7919, 28),
      ))
    }

public val Res.string.duration: StringResource by lazy {
      StringResource("string:duration", "duration", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9076, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7948, 28),
      ))
    }

public val Res.string.edit: StringResource by lazy {
      StringResource("string:edit", "edit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9101, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7977, 20),
      ))
    }

public val Res.string.effortless_efficiency: StringResource by lazy {
      StringResource("string:effortless_efficiency", "effortless_efficiency", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9130, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7998, 57),
      ))
    }

public val Res.string.email: StringResource by lazy {
      StringResource("string:email", "email", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9446, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8294, 21),
      ))
    }

public val Res.string.email_address: StringResource by lazy {
      StringResource("string:email_address", "email_address", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9240, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8108, 41),
      ))
    }

public val Res.string.email_address_mandatory: StringResource by lazy {
      StringResource("string:email_address_mandatory", "email_address_mandatory", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9184, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8056, 51),
      ))
    }

public val Res.string.email_capital: StringResource by lazy {
      StringResource("string:email_capital", "email_capital", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9282, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8150, 29),
      ))
    }

public val Res.string.email_format_not_valid: StringResource by lazy {
      StringResource("string:email_format_not_valid", "email_format_not_valid", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9312, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8180, 66),
      ))
    }

public val Res.string.email_required: StringResource by lazy {
      StringResource("string:email_required", "email_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9391, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8247, 46),
      ))
    }

public val Res.string.employee: StringResource by lazy {
      StringResource("string:employee", "employee", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9763, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8575, 28),
      ))
    }

public val Res.string.employee_added_successfully: StringResource by lazy {
      StringResource("string:employee_added_successfully", "employee_added_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9468, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8316, 67),
      ))
    }

public val Res.string.employee_comments: StringResource by lazy {
      StringResource("string:employee_comments", "employee_comments", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9548, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8384, 49),
      ))
    }

public val Res.string.employee_details: StringResource by lazy {
      StringResource("string:employee_details", "employee_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9606, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8434, 40),
      ))
    }

public val Res.string.employee_updated_successfully: StringResource by lazy {
      StringResource("string:employee_updated_successfully", "employee_updated_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9651, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8475, 73),
      ))
    }

public val Res.string.employees: StringResource by lazy {
      StringResource("string:employees", "employees", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9733, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8549, 25),
      ))
    }

public val Res.string.employment_details: StringResource by lazy {
      StringResource("string:employment_details", "employment_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9796, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8604, 50),
      ))
    }

public val Res.string.end_at: StringResource by lazy {
      StringResource("string:end_at", "end_at", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9847, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8655, 22),
      ))
    }

public val Res.string.end_time: StringResource by lazy {
      StringResource("string:end_time", "end_time", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9874, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8678, 28),
      ))
    }

public val Res.string.enter_building_number: StringResource by lazy {
      StringResource("string:enter_building_number", "enter_building_number", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9903, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8707, 81),
      ))
    }

public val Res.string.enter_city: StringResource by lazy {
      StringResource("string:enter_city", "enter_city", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 9981, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8789, 34),
      ))
    }

public val Res.string.enter_contact_name: StringResource by lazy {
      StringResource("string:enter_contact_name", "enter_contact_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10020, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8824, 50),
      ))
    }

public val Res.string.enter_country: StringResource by lazy {
      StringResource("string:enter_country", "enter_country", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10079, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8875, 41),
      ))
    }

public val Res.string.enter_email_address: StringResource by lazy {
      StringResource("string:enter_email_address", "enter_email_address", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10121, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8917, 55),
      ))
    }

public val Res.string.enter_employee_email: StringResource by lazy {
      StringResource("string:enter_employee_email", "enter_employee_email", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10185, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8973, 68),
      ))
    }

public val Res.string.enter_feedback: StringResource by lazy {
      StringResource("string:enter_feedback", "enter_feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10274, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9042, 78),
      ))
    }

public val Res.string.enter_full_name: StringResource by lazy {
      StringResource("string:enter_full_name", "enter_full_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10345, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9121, 43),
      ))
    }

public val Res.string.enter_job_title: StringResource by lazy {
      StringResource("string:enter_job_title", "enter_job_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10413, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9165, 43),
      ))
    }

public val Res.string.enter_site_name: StringResource by lazy {
      StringResource("string:enter_site_name", "enter_site_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10465, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9209, 43),
      ))
    }

public val Res.string.enter_step_title: StringResource by lazy {
      StringResource("string:enter_step_title", "enter_step_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10525, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9253, 48),
      ))
    }

public val Res.string.enter_street: StringResource by lazy {
      StringResource("string:enter_street", "enter_street", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10586, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9302, 60),
      ))
    }

public val Res.string.enter_surname: StringResource by lazy {
      StringResource("string:enter_surname", "enter_surname", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10655, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9363, 53),
      ))
    }

public val Res.string.enter_text: StringResource by lazy {
      StringResource("string:enter_text", "enter_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10717, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9417, 34),
      ))
    }

public val Res.string.enter_time: StringResource by lazy {
      StringResource("string:enter_time", "enter_time", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10756, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9452, 34),
      ))
    }

public val Res.string.enter_workspace_name: StringResource by lazy {
      StringResource("string:enter_workspace_name", "enter_workspace_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10795, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9487, 72),
      ))
    }

public val Res.string.enter_your_email: StringResource by lazy {
      StringResource("string:enter_your_email", "enter_your_email", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10880, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9560, 48),
      ))
    }

public val Res.string.enter_zip: StringResource by lazy {
      StringResource("string:enter_zip", "enter_zip", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10984, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9652, 37),
      ))
    }

public val Res.string.enter_zip_code: StringResource by lazy {
      StringResource("string:enter_zip_code", "enter_zip_code", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10945, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9609, 42),
      ))
    }

public val Res.string.error: StringResource by lazy {
      StringResource("string:error", "error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11487, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10035, 21),
      ))
    }

public val Res.string.error_employee_number: StringResource by lazy {
      StringResource("string:error_employee_number", "error_employee_number", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11034, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9690, 137),
      ))
    }

public val Res.string.error_manager_number: StringResource by lazy {
      StringResource("string:error_manager_number", "error_manager_number", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11216, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9828, 136),
      ))
    }

public val Res.string.error_message: StringResource by lazy {
      StringResource("string:error_message", "error_message", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11389, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9965, 69),
      ))
    }

public val Res.string.estimated_duration: StringResource by lazy {
      StringResource("string:estimated_duration", "estimated_duration", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11509, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10057, 50),
      ))
    }

public val Res.string.every_2_weeks: StringResource by lazy {
      StringResource("string:every_2_weeks", "every_2_weeks", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11560, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10108, 41),
      ))
    }

public val Res.string.every_day: StringResource by lazy {
      StringResource("string:every_day", "every_day", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11602, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10150, 29),
      ))
    }

public val Res.string.every_month: StringResource by lazy {
      StringResource("string:every_month", "every_month", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11632, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10180, 35),
      ))
    }

public val Res.string.every_week: StringResource by lazy {
      StringResource("string:every_week", "every_week", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11668, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10216, 34),
      ))
    }

public val Res.string.expand_your_team: StringResource by lazy {
      StringResource("string:expand_your_team", "expand_your_team", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11703, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10251, 116),
      ))
    }

public val Res.string.export_list: StringResource by lazy {
      StringResource("string:export_list", "export_list", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11832, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10368, 35),
      ))
    }

public val Res.string.fast_track: StringResource by lazy {
      StringResource("string:fast_track", "fast_track", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11963, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10475, 62),
      ))
    }

public val Res.string.fast_track_support: StringResource by lazy {
      StringResource("string:fast_track_support", "fast_track_support", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 11876, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10404, 70),
      ))
    }

public val Res.string.february: StringResource by lazy {
      StringResource("string:february", "february", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12042, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10538, 28),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("contact_person", Res.string.contact_person)
  map.put("contact_site", Res.string.contact_site)
  map.put("contact_type", Res.string.contact_type)
  map.put("contact_type_contractor", Res.string.contact_type_contractor)
  map.put("contact_type_customer", Res.string.contact_type_customer)
  map.put("contact_type_supplier", Res.string.contact_type_supplier)
  map.put("contact_updated_successfully", Res.string.contact_updated_successfully)
  map.put("contact_us", Res.string.contact_us)
  map.put("contacting_support_for_assistance", Res.string.contacting_support_for_assistance)
  map.put("contacts", Res.string.contacts)
  map.put("continue_cancellation", Res.string.continue_cancellation)
  map.put("continue_with_apple", Res.string.continue_with_apple)
  map.put("continue_with_fb", Res.string.continue_with_fb)
  map.put("continue_with_google", Res.string.continue_with_google)
  map.put("continue_with_microsoft", Res.string.continue_with_microsoft)
  map.put("continue_with_next_step", Res.string.continue_with_next_step)
  map.put("country", Res.string.country)
  map.put("country_required", Res.string.country_required)
  map.put("create", Res.string.create)
  map.put("create_new_employee", Res.string.create_new_employee)
  map.put("create_new_task", Res.string.create_new_task)
  map.put("create_one", Res.string.create_one)
  map.put("create_strong_password", Res.string.create_strong_password)
  map.put("create_workspace", Res.string.create_workspace)
  map.put("create_your_first_team", Res.string.create_your_first_team)
  map.put("current_plan", Res.string.current_plan)
  map.put("custom", Res.string.custom)
  map.put("daily_activities", Res.string.daily_activities)
  map.put("damage_desc", Res.string.damage_desc)
  map.put("damage_title", Res.string.damage_title)
  map.put("dashboard", Res.string.dashboard)
  map.put("date", Res.string.date)
  map.put("date_error", Res.string.date_error)
  map.put("day", Res.string.day)
  map.put("day_free_trial", Res.string.day_free_trial)
  map.put("deadline_and_duration", Res.string.deadline_and_duration)
  map.put("december", Res.string.december)
  map.put("dedicated_support", Res.string.dedicated_support)
  map.put("delete", Res.string.delete)
  map.put("delete_contact", Res.string.delete_contact)
  map.put("delete_job", Res.string.delete_job)
  map.put("delete_site", Res.string.delete_site)
  map.put("describe_the_process", Res.string.describe_the_process)
  map.put("details", Res.string.details)
  map.put("document", Res.string.document)
  map.put("documents", Res.string.documents)
  map.put("done_selecting_dates", Res.string.done_selecting_dates)
  map.put("downgrading_to_lower", Res.string.downgrading_to_lower)
  map.put("due_date", Res.string.due_date)
  map.put("duration", Res.string.duration)
  map.put("edit", Res.string.edit)
  map.put("effortless_efficiency", Res.string.effortless_efficiency)
  map.put("email", Res.string.email)
  map.put("email_address", Res.string.email_address)
  map.put("email_address_mandatory", Res.string.email_address_mandatory)
  map.put("email_capital", Res.string.email_capital)
  map.put("email_format_not_valid", Res.string.email_format_not_valid)
  map.put("email_required", Res.string.email_required)
  map.put("employee", Res.string.employee)
  map.put("employee_added_successfully", Res.string.employee_added_successfully)
  map.put("employee_comments", Res.string.employee_comments)
  map.put("employee_details", Res.string.employee_details)
  map.put("employee_updated_successfully", Res.string.employee_updated_successfully)
  map.put("employees", Res.string.employees)
  map.put("employment_details", Res.string.employment_details)
  map.put("end_at", Res.string.end_at)
  map.put("end_time", Res.string.end_time)
  map.put("enter_building_number", Res.string.enter_building_number)
  map.put("enter_city", Res.string.enter_city)
  map.put("enter_contact_name", Res.string.enter_contact_name)
  map.put("enter_country", Res.string.enter_country)
  map.put("enter_email_address", Res.string.enter_email_address)
  map.put("enter_employee_email", Res.string.enter_employee_email)
  map.put("enter_feedback", Res.string.enter_feedback)
  map.put("enter_full_name", Res.string.enter_full_name)
  map.put("enter_job_title", Res.string.enter_job_title)
  map.put("enter_site_name", Res.string.enter_site_name)
  map.put("enter_step_title", Res.string.enter_step_title)
  map.put("enter_street", Res.string.enter_street)
  map.put("enter_surname", Res.string.enter_surname)
  map.put("enter_text", Res.string.enter_text)
  map.put("enter_time", Res.string.enter_time)
  map.put("enter_workspace_name", Res.string.enter_workspace_name)
  map.put("enter_your_email", Res.string.enter_your_email)
  map.put("enter_zip", Res.string.enter_zip)
  map.put("enter_zip_code", Res.string.enter_zip_code)
  map.put("error", Res.string.error)
  map.put("error_employee_number", Res.string.error_employee_number)
  map.put("error_manager_number", Res.string.error_manager_number)
  map.put("error_message", Res.string.error_message)
  map.put("estimated_duration", Res.string.estimated_duration)
  map.put("every_2_weeks", Res.string.every_2_weeks)
  map.put("every_day", Res.string.every_day)
  map.put("every_month", Res.string.every_month)
  map.put("every_week", Res.string.every_week)
  map.put("expand_your_team", Res.string.expand_your_team)
  map.put("export_list", Res.string.export_list)
  map.put("fast_track", Res.string.fast_track)
  map.put("fast_track_support", Res.string.fast_track_support)
  map.put("february", Res.string.february)
}
